<template>
  <b-card no-body>
    <div class="card-body p-1">
      <div class="row">

        <div class="col-12 col-md-4">
          <b-form-group
            label="Kỳ thống kê"
            class="mb-0"
          >
            <b-form-select
              v-model="localSearchQuery.filter_id"
              :options="filterOptions"
              class="w-100"
              :reduce="(val) => val.id"
              label="label"
              placeholder="--Chọn--"
            />
          </b-form-group>
        </div>

        <div
          v-if="localSearchQuery.filter_id == 2"
          class="col-12 col-md-4"
        >
          <b-form-group
            label="Khoảng thời gian đặt"
            label-for="borr"
          >
            <div class="input-group">
              <flat-pickr
                v-model="localSearchQuery.book_date"
                :value="localSearchQuery.book_date"
                class="form-control"
                :config="configDateRange"
                placeholder="dd/mm/yyyy - dd/mm/yyyy"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-default"
                  style="border-color: #d8d6de;"
                  type="button"
                  title="Xóa"
                  data-clear
                >
                  <feather-icon icon="XIcon" />
                </button>
              </div>
            </div>
          </b-form-group>

        </div>
        <div class="col-12 col-md-2">
          <b-form-group
            v-if="localSearchQuery.filter_id == 1"
            label="Năm"
            class="mb-0"
          >
            <b-form-select
              v-model="localSearchQuery.year"
              :options="dataYear"
              class="w-100"
              :reduce="(val) => val.id"
              label="label"
              placeholder="--Chọn--"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-2">
          <b-form-group
            v-if="localSearchQuery.filter_id == 1"
            label="Tháng"
            class="mb-0"
          >
            <b-form-select
              v-model="localSearchQuery.month"
              :options="dataMonth"
              class="w-100"
              :reduce="(val) => val.id"
              label="label"
              placeholder="--Chọn--"
            />
          </b-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-4 mt-1">
          <b-button
            variant="primary"
            @click="updateSearchQuery"
            @keyup.enter="updateSearchQuery"
          >
            <feather-icon icon="SearchIcon" /> Tìm kiếm
          </b-button>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BFormGroup,
  BFormSelect,
} from 'bootstrap-vue';
import { ref } from '@vue/composition-api';
// import useCategoryTypeDevice from './useCategoryTypeDevice';
import flatPickr from 'vue-flatpickr-component';

import vSelect from 'vue-select'
import { Vietnamese } from 'flatpickr/dist/l10n/vn';

import store from '@/store'
import useStatistical from './useStatistical';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    flatPickr,
    BFormGroup,
    vSelect,
    BFormSelect,
  },
  props: {
    searchQuery: ref({}),
  },

  data() {
    return {
      dataMonth: [
        { value: 1, text: 'Tháng 1' },
        { value: 2, text: 'Tháng 2' },
        { value: 3, text: 'Tháng 3' },
        { value: 4, text: 'Tháng 4' },
        { value: 5, text: 'Tháng 5' },
        { value: 6, text: 'Tháng 6' },
        { value: 7, text: 'Tháng 7' },
        { value: 8, text: 'Tháng 8' },
        { value: 9, text: 'Tháng 9' },
        { value: 10, text: 'Tháng 10' },
        { value: 11, text: 'Tháng 11' },
        { value: 12, text: 'Tháng 12' },
      ],
    }
  },

  setup(props, { emit }) {
    const { statusOptions } = useStatistical();
    const dataStudio = ref([])
    const filterOptions = [
      { text: 'Tháng', value: 1 },
      { text: 'Khoảng thời gian', value: 2 },
    ];
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const localSearchQuery = ref({
      book_date: '',
      year: currentYear,
      month: currentMonth,
      filter_id: 1,
    });
    const updateSearchQuery = () => {
      emit('search', localSearchQuery.value);
    };
    Vietnamese.rangeSeparator = ' - ';
    const configDate = ref({
      dateFormat: 'd/m/Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });
    const configDateRange = ref({
      dateFormat: 'd/m/Y',
      mode: 'range',
      wrap: true,
      showMonths: 2,
      locale: Vietnamese, // locale for this instance only
    });
    const dataYear = ref([{ value: currentYear, text: currentYear }]);
    for (let i = 1; i < 10; i += 1) {
      const val = currentYear - i;
      dataYear.value.push({ value: val, text: val });
    }
    return {
      localSearchQuery,
      updateSearchQuery,
      configDate,
      configDateRange,
      statusOptions,
      dataStudio,
      filterOptions,
      dataYear,
    };
  },
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
